// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__AC87m","list":"styles_list__2D8RM"};